import { render, staticRenderFns } from "./goodsContacts.vue?vue&type=template&id=3ca99c78&scoped=true"
import script from "./goodsContacts.vue?vue&type=script&lang=js"
export * from "./goodsContacts.vue?vue&type=script&lang=js"
import style0 from "./goodsContacts.vue?vue&type=style&index=0&id=3ca99c78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca99c78",
  null
  
)

export default component.exports